import { render } from "./Pricing.vue?vue&type=template&id=8d5ddc74"
import script from "./Pricing.vue?vue&type=script&lang=js"
export * from "./Pricing.vue?vue&type=script&lang=js"

import "./Pricing.vue?vue&type=style&index=0&id=8d5ddc74&lang=scss"
script.render = render

export default script